import { JSONContent } from '@tiptap/core';
import {
  CustomSectionAttributes,
  CustomSectionNodeType,
} from 'api/custom-section/types';
import { PagesAPI } from 'api/pages';
import { useCallback } from 'react';

export const useDefaultCustomSectionNodeResolver = ({
  documentId,
}: {
  documentId: number;
}): ((
  attributes: CustomSectionAttributes,
  payload?: JSONContent[],
) => Promise<any>) => {
  return useCallback(
    async (attributes: CustomSectionAttributes, payload?: JSONContent[]) => {
      return PagesAPI.resolveCustomSection(documentId, {
        type: CustomSectionNodeType.RlCustomSection,
        attrs: attributes,
        content: payload ?? [],
      }).then((response) => response);
    },
    [documentId],
  );
};
